import type { HTMLAttributes, ReactNode } from 'react';
import { clsx } from 'clsx';
import { HorizontalStack } from '../../alignment/horizontal-stack';
import styles from './dialog-header.module.scss';

export interface DialogHeaderProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  leftAction?: ReactNode;
  rightAction?: ReactNode;
  title: ReactNode;
  withoutBorder?: boolean;
}

export function DialogHeader({ className, leftAction, rightAction, title, withoutBorder, ...rest }: DialogHeaderProps) {
  return (
    <div className={clsx(styles.dialogHeader, className, withoutBorder && styles.withoutBorder)}>
      <HorizontalStack className={styles.container} gap={4} wrap="nowrap" {...rest}>
        <div className={styles.action}>{leftAction}</div>
        {title ? <div className={styles.title}>{title}</div> : null}
        <div className={styles.action}>{rightAction}</div>
      </HorizontalStack>
    </div>
  );
}
